import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import QueryParameters from "../api/QueryParameters";
import { sendUnsubscribeRequest } from "../api/requests";
import { buildThankYouUrl } from "../views/ThankYou";
import ErrorMessage from "./ErrorMessage";

interface UnsubscribeProps {
  confirmButtonLabel: string;
  thankYouLabel: string;
  errorMessage: string;
}

const UNSUBSCRIBE_LINK_QUERY_SELECTOR = ".unsub";

// Component attaching to unsubscribe link that is rendered as a part of labels coming from backend
export default function UnsubscribeLink(props: UnsubscribeProps) {
  const history = useHistory();
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  const onClickHandler = () => {
    const queryParams = new QueryParameters();

    sendUnsubscribeRequest(queryParams)
      .then((status) => {
        if (status) {
          history.push({
            ...buildThankYouUrl(queryParams),
            state: { label: props.thankYouLabel, buttonLabel: props.confirmButtonLabel }
          });
        } else {
          setShowErrorMessage(true);
        }
      })
      .catch((error) => {
        setShowErrorMessage(true);
      });
  };

  //As unsubscribe links are not rendered natively by React we are using vanilla JS to attach on click event listeners
  useEffect(() => {
    const onClickListener = (event: Event) => {
      event.preventDefault();
      onClickHandler();
    };
    // Attach event listeners to links when component is rendered
    const elements = document.querySelectorAll(UNSUBSCRIBE_LINK_QUERY_SELECTOR);
    elements.forEach((el) => el.setAttribute("href", "#"));
    elements.forEach((el) => el.addEventListener("click", onClickListener));

    // returned function will be called on component unmount. Removing listeners
    return () => {
      elements.forEach((el) => el.removeEventListener("click", onClickListener));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>{showErrorMessage ? <ErrorMessage errorMessage={props.errorMessage} /> : ""}</div>;
}
